export default "__VITE_ASSET__A$SkeYF8__"